import type { MultiPoligono, Poligono, Anillo, Punto } from './geometria';

/**
 * Lector minimo de WKT para los poligonos que devuelve CartoCiudad (limites municipales en
 * WGS84): POLYGON y MULTIPOLYGON, con o sin espacios tras la palabra clave. Los anillos se
 * devuelven sin repetir el vertice de cierre, como el resto de la geometria de la aplicacion.
 */
export function parsearWktMultiPoligono(wkt: string): MultiPoligono {
  const m = /^\s*(MULTIPOLYGON|POLYGON)\s*(\(.*\))\s*$/is.exec(wkt);
  if (!m) throw new Error('WKT no reconocido: se esperaba POLYGON o MULTIPOLYGON');
  const tipo = m[1].toUpperCase();
  const cuerpo = m[2];
  const textosPoligono: string[] = tipo === 'POLYGON' ? [cuerpo] : [];
  if (tipo === 'MULTIPOLYGON') {
    // ((( r ), ( r )), (( r ))) -> cada poligono es un grupo "(( ... ))".
    const re = /\(\s*((?:\([^()]*\)\s*,?\s*)+)\)/g;
    const interior = cuerpo.slice(1, -1);
    let g: RegExpExecArray | null;
    while ((g = re.exec(interior)) !== null) textosPoligono.push(`(${g[1]})`);
  }
  const salida: MultiPoligono = [];
  for (const texto of textosPoligono) {
    const poligono: Poligono = [];
    const re = /\(([^()]+)\)/g;
    let r: RegExpExecArray | null;
    while ((r = re.exec(texto)) !== null) {
      const anillo: Anillo = [];
      for (const par of r[1].split(',')) {
        const v = par.trim().split(/\s+/);
        if (v.length < 2) continue;
        const x = Number(v[0]), y = Number(v[1]);
        if (!Number.isFinite(x) || !Number.isFinite(y)) continue;
        anillo.push([x, y] as Punto);
      }
      if (anillo.length >= 2) {
        const a = anillo[0], b = anillo[anillo.length - 1];
        if (a[0] === b[0] && a[1] === b[1]) anillo.pop();
      }
      if (anillo.length >= 3) poligono.push(anillo);
    }
    if (poligono.length) salida.push(poligono);
  }
  if (salida.length === 0) throw new Error('WKT sin anillos validos');
  return salida;
}
